import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock, Instagram } from "lucide-react";
import { CONTACT, SERVICE_GROUPS } from "../data/company";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-900 border-t border-white/10">
    <div className="container-site py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-5">
          <img
            src="/assets/logo-mark-gold.png"
            alt="Logo PT. Luminara Global Persada"
            className="w-11 h-11 object-contain"
          />
          <span className="font-heading font-semibold text-white">PT. Luminara Global Persada</span>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Perusahaan yang bergerak di bidang konstruksi, perdagangan, arsitektur, interior, dan lanskap —
          berorientasi pada kualitas, ketepatan waktu, integritas, dan solusi terpadu.
        </p>
      </div>

      <nav aria-label="Tautan halaman">
        <h3 className="kicker mb-5">Navigasi</h3>
        <ul className="space-y-3 text-sm">
          <li><Link data-testid="footer-link-beranda" to="/" className="text-slate-400 hover:text-gold transition-colors duration-300">Beranda</Link></li>
          <li><Link data-testid="footer-link-tentang" to="/tentang" className="text-slate-400 hover:text-gold transition-colors duration-300">Tentang Perusahaan</Link></li>
          <li><Link data-testid="footer-link-layanan" to="/layanan" className="text-slate-400 hover:text-gold transition-colors duration-300">Layanan</Link></li>
          <li><Link data-testid="footer-link-proyek" to="/proyek" className="text-slate-400 hover:text-gold transition-colors duration-300">Proyek</Link></li>
          <li><Link data-testid="footer-link-kontak" to="/kontak" className="text-slate-400 hover:text-gold transition-colors duration-300">Kontak</Link></li>
          <li><Link data-testid="footer-link-admin" to="/admin" className="text-slate-500 hover:text-gold transition-colors duration-300">Area Admin</Link></li>
        </ul>
      </nav>

      <nav aria-label="Tautan layanan">
        <h3 className="kicker mb-5">Layanan</h3>
        <ul className="space-y-3 text-sm">
          {SERVICE_GROUPS.map((g) => (
            <li key={g.id}>
              <Link
                data-testid={`footer-service-${g.id}`}
                to={`/layanan#${g.id}`}
                className="text-slate-400 hover:text-gold transition-colors duration-300"
              >
                {g.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="kicker mb-5">Kontak</h3>
        <ul className="space-y-4 text-sm text-slate-400">
          <li className="flex gap-3">
            <MapPin size={16} className="text-gold shrink-0 mt-0.5" />
            <span>{CONTACT.address}</span>
          </li>
          <li className="flex gap-3">
            <Mail size={16} className="text-gold shrink-0 mt-0.5" />
            <span className="flex flex-col gap-1">
              <a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="hover:text-gold transition-colors duration-300">
                {CONTACT.email}
              </a>
              <a data-testid="footer-email2-link" href={`mailto:${CONTACT.email2}`} className="hover:text-gold transition-colors duration-300">
                {CONTACT.email2}
              </a>
            </span>
          </li>
          <li className="flex gap-3 items-center">
            <Phone size={16} className="text-gold shrink-0" />
            <a data-testid="footer-phone-link" href={CONTACT.waLink} target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors duration-300">
              {CONTACT.phoneDisplay}
            </a>
          </li>
          <li className="flex gap-3 items-center">
            <Instagram size={16} className="text-gold shrink-0" />
            <a data-testid="footer-instagram-link" href="https://instagram.com/luminaraglobalpersada" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors duration-300">
              @luminaraglobalpersada
            </a>
          </li>
          <li className="flex gap-3">
            <Clock size={16} className="text-gold shrink-0 mt-0.5" />
            <span>Senin – Jumat 08.00 – 17.00 WIB<br />Sabtu 08.00 – 12.00 WIB</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-site py-6 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">
          &copy; {new Date().getFullYear()} PT. Luminara Global Persada. Seluruh hak cipta dilindungi.
        </p>
        <p className="text-xs text-slate-500 tracking-wide uppercase">
          Konstruksi &bull; Perdagangan &bull; Arsitektur &bull; Interior &bull; Lanskap
        </p>
      </div>
    </div>
  </footer>
);
